import { Routes, Route } from 'react-router-dom';
import loadable from '@loadable/component';
import AuthProvider from '../../providers/auth.provider';
import { config } from '../../config';

const liffId = config.liff_id.documentsDownload;

const DocumentList = loadable(() => import('./documentList'), { fallback: null });

const DocumentDetail = loadable(() => import('./documentDetail'), { fallback: null });

const NotFound = loadable(() => import('../NotFound'), { fallback: null });

export default function DocumentRoute() {
	return (
		<Routes>
			<Route path="/" element={
				<AuthProvider liffId={liffId}>
					<DocumentList />
				</AuthProvider>} />
			<Route path="detail" element={
				<AuthProvider liffId={liffId}>
					<DocumentDetail />
				</AuthProvider>} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
}
